import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <nav className={`rk-navbar${scrolled ? ' scrolled' : ''}`}>
        <div className="rk-navbar-inner">
          <Link to="/" className="rk-logo" onClick={() => setMenuOpen(false)}>
            <div className="rk-logo-icon">
              <i className="bi bi-shield-fill"></i>
            </div>
            <div>
              <span className="rk-logo-text">RAKSHA</span>
              <span className="rk-logo-sub">Ireland</span>
            </div>
          </Link>

          <ul className="rk-nav-links">
            <li><NavLink to="/" end>Home</NavLink></li>
            <li><NavLink to="/features">Features</NavLink></li>
            <li><NavLink to="/how-it-works">How It Works</NavLink></li>
            <li><NavLink to="/contact">Contact</NavLink></li>
          </ul>

          <a href="#download" className="rk-download-btn" onClick={() => setMenuOpen(false)}>
            Download App
          </a>

          <button
            className="rk-hamburger"
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Toggle menu"
          >
            <i className={`bi ${menuOpen ? 'bi-x-lg' : 'bi-list'}`}></i>
          </button>
        </div>
      </nav>

      <div className={`rk-mobile-menu${menuOpen ? ' open' : ''}`}>
        <NavLink to="/" end onClick={() => setMenuOpen(false)}>Home</NavLink>
        <NavLink to="/features" onClick={() => setMenuOpen(false)}>Features</NavLink>
        <NavLink to="/how-it-works" onClick={() => setMenuOpen(false)}>How It Works</NavLink>
        <NavLink to="/privacy-policy" onClick={() => setMenuOpen(false)}>Privacy Policy</NavLink>
        <NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact</NavLink>
        <a href="#download" className="rk-mobile-download" onClick={() => setMenuOpen(false)}>
          <i className="bi bi-google-play"></i> Download App
        </a>
      </div>
    </>
  );
}
